"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDisplayAmount = void 0;
const helpers_1 = require("@/helpers");
const formatDisplayAmount = (amount, decimalPlaces = 2) => {
    const formattedAmount = typeof amount === "string" ? Number((0, helpers_1.removeThousandSeparator)(amount)) : amount;
    if ((formattedAmount - Math.floor(formattedAmount)) !== 0) {
        return formattedAmount.toFixed(decimalPlaces).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
    else {
        return formattedAmount.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
};
exports.formatDisplayAmount = formatDisplayAmount;
